/**
 * useHomepageStats — canonical source for the marketing counters shown on
 * Home.jsx, Partnerships.jsx and any other surface referencing
 * "partner universities / countries / B-schools" figures.
 *
 * Do NOT hardcode any of these numbers anywhere on the frontend — always
 * import this hook. Backend endpoint `/api/homepage/stats` computes the
 * values live from the partnerships + country_playbooks collections, so
 * the site auto-updates when the underlying dataset changes.
 *
 * Returns an object with numbers when loaded, `null` when still loading.
 * The most recent successful fetch is cached in-module so repeated calls
 * across pages during the same session don't re-hit the endpoint.
 */
import { useEffect, useState } from "react";
import { api } from "./api";

let _cache = null; // last successful result. Shared across mounts

export function useHomepageStats() {
  const [stats, setStats] = useState(_cache);

  useEffect(() => {
    let cancelled = false;
    api.get("/homepage/stats")
      .then((r) => {
        if (cancelled) return;
        _cache = r.data;
        setStats(r.data);
      })
      .catch(() => { /* stay null; UI must handle */ });
    return () => { cancelled = true; };
  }, []);

  return stats;
}
